module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/l1Rqry/tc-custom/cover.jpeg?1685203786723?1702553745716",
      "alt": "This image is the cover for the book If Only For One Night"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("If Only For One Night\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('i', [_vm._v("Can they be soulmates if they're married to other people?")]), _vm._v(" From the outside, Angelique has the perfect life - a rich husband who adores her and gives her the world, except for what she craves most - his attention. A  workaholic, more concerned with his family's financial situation than emotional stability, Preston doesn't understand why his wife is so unhappy. Not one to stray, Angelique seeks comfort in the online game, Words With Friends. Blu has been living a life of loneliness since his wife settled into a depression she has no desire to shake. Frustrated and fed up, he loses himself in his favorite game - and the woman that has proven to be a formidable opponent. It's not long before their online connection turns flirtatious and troubles at home lead them to a face-to-face meeting. And eventually an addictive connection that will have them questioning if they're truly soulmates or if they were destined for only one night.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Victoria Christopher Murray, ReShonda Tate Billingsley\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Between them, National Bestselling and NAACP Award-Winning authors, ReShonda Tate Billingsley and Victoria Christopher Murray have more than two million books in print. The dynamic duo decided to combine their respective talents writing a number of books together, while maintaining their successful solo careers. Victoria, a former successful entrepreneur, also holds an MBA from New York University. ReShonda is a former TV journalist and marketing professional with over 25 years of experience.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0